// extracted by mini-css-extract-plugin
module.exports = {"draggingToolTip":"idt-draggingtooltip_draggingtooltip__9yuic","draggingTooltipCopy":"idt-draggingtooltip_draggingtooltipcopy__1dv1l"};